import _toConsumableArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import NewArrivalsHeader from "@/pages/new-arrivals/new-arrivals/NewArrivalsHeader";
import stl from "./NewArrivals.module.css";
import { useEffect, useState } from "react";
import { api__getNewArrivals, api__updateLastSeen } from "@/apis/posts/getNewArrivals";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "@i18n";
import { CarCardPlaceHolderGrid } from "@componentsShared/placeholders/CarCardPlaceHolder";
import UnbxdRecommendationCards from "@/components/SearchComponent/UnbxdComponents/UnbxdRecommendation/UnbxRecommendationCards";
import Layout from "@/_LayoutsRelated/layout/Layout";
import { trackEvents } from "@/common/events/events";
import BackButton from "@/components/UiKit/Buttons/BackButton/BackButton";
import useHelpers from "@hooks/useHelpers";
import { useSession } from "@/_MiniApps/auth/AuthContext";
import useCookieClient from "@hooks/useCookieClient";
import { ModernCard } from "@/components/SearchComponent/ModernCard";
var NewArrivals = function NewArrivals() {
  var _useState = useState([]),
    data = _useState[0],
    setData = _useState[1];
  var _useState2 = useState(true),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl,
    navigateTo = _useHelpers.navigateTo;
  var location = useLocation();
  var _useSession = useSession(),
    userData = _useSession.user;
  var _useCookieClient = useCookieClient(),
    getCookieClient = _useCookieClient.getCookieClient;
  useEffect(function () {
    var searchParams = new URLSearchParams(location.search);
    var make_id = searchParams.get('make_id');
    var model_id = searchParams.get('model_id');
    var condition_id = searchParams.get('condition_id');
    var notification_id = searchParams.get('notification_id');
    var param = {
      filters: _objectSpread(_objectSpread(_objectSpread({}, make_id && {
        make_id: make_id
      }), model_id && {
        model_id: model_id
      }), condition_id && {
        condition_id: condition_id
      }),
      sort: "-first_active_date",
      size: 8
    };
    api__getNewArrivals(param).then(function (res) {
      setLoading(false);
      setData(_toConsumableArray(res === null || res === void 0 ? void 0 : res.products));
      trackEvents("notification_whatsapp_open", {
        uuid: getCookieClient("UUID"),
        user_id: userData !== null && userData !== void 0 && userData.phone_number ? "9665" + userData.phone_number : "null"
      });
      if (notification_id) {
        api__updateLastSeen(parseInt(notification_id)).then(function (success) {
          if (success) {
            console.log("Last seen updated successfully");
          } else {
            console.log("Failed to update last seen notification");
          }
        })["catch"](function (err) {
          console.error("Error sending notification:", err);
        });
      }
    });
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Layout, {
    headHideLinks: true,
    hideAppBanner: true,
    linksForSearch: true,
    hideOrangeHeadBtn: true,
    mobileHasBack: true
  }, loading ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("section", {
    className: stl.container
  }, /*#__PURE__*/React.createElement(CarCardPlaceHolderGrid, {
    length: 20,
    columnWidth: 275
  }))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("section", {
    className: stl.container
  }, /*#__PURE__*/React.createElement(BackButton, {
    className: [stl.mb16, stl.hideMobile].join(" "),
    onClick: function onClick() {
      return navigateTo("/");
    }
  }, /*#__PURE__*/React.createElement("span", null, t("رجوع", {
    ns: "web_common"
  }))), /*#__PURE__*/React.createElement(NewArrivalsHeader, {
    haveResult: (data === null || data === void 0 ? void 0 : data.length) > 0
  }), (data === null || data === void 0 ? void 0 : data.length) > 0 ? /*#__PURE__*/React.createElement("section", {
    className: stl.cardsGrid
  }, data.map(function (post, i) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ModernCard, {
      post: post,
      rank: i + 1,
      page: 1,
      referralLocation: "new_arrival",
      sectionType: "new arrivals"
    }));
  })) : /*#__PURE__*/React.createElement("section", {
    className: stl.recommendation
  }, /*#__PURE__*/React.createElement(UnbxdRecommendationCards, {
    recommendations: 12,
    referral_location: "new_arrival"
  })), /*#__PURE__*/React.createElement("div", {
    className: [stl.showRecommendedCarsSection].join(' ')
  }, /*#__PURE__*/React.createElement(Link, {
    to: createUrl("/filters"),
    className: stl.showAllRecommendedCarsButton
  }, t("شاهد جميع السيارات", {
    ns: "web_common"
  })))))));
};
export default NewArrivals;